import axios, { AxiosRequestConfig } from 'axios';
import ApiURLs from '@/ApiURLs';
import EmailInvitationModel from '@/models/enrollment/emailInvitationModel';
import Child from '@/models/enrollment/child';
import ChildIdentity from '@/models/enrollment/childIdentity';
import SchoolArrangement from '@/models/enrollment/schoolArrangement';
import PickupPerson from '@/models/enrollment/pickupPerson';
import SleepArragement from '@/models/enrollment/sleepArragement';
import PhysicalRequirement from '@/models/enrollment/physicalRequirement';
import EmergencyContact from '@/models/enrollment/emergencyContact';

export class ChildServiceCommands {
    putInQueue() {
        return axios.post(ApiURLs.putIntoQueue);
    }

    sendInvitation(data: EmailInvitationModel) {
        return axios.post(ApiURLs.sendInvitation, data);
    }

    sendProviderInvitation(data: EmailInvitationModel) {
        return axios.post(ApiURLs.sendProviderInvitation, data);
    }

    saveChildInfo(data: Child) {
        return axios.post(ApiURLs.saveChildInfo, data);
    }

    updateChildInfo(data: ChildIdentity) {
        return axios.post(ApiURLs.updateChildInfo, data);
    }

    updateSchoolArrangement(data: SchoolArrangement) {
        const blah = ApiURLs.updateSchoolArrangementInfo;
        
        return axios.post(ApiURLs.updateSchoolArrangementInfo, data);
    }
    
    saveSchoolArrangementInfo(data: SchoolArrangement) {
        return axios.post(ApiURLs.saveSchoolArrangementInfo, data);
    }
    
    saveCustodyArrangement(data:any) {
        return axios.post(ApiURLs.saveCustodyArrangement, data);
    }

    updateCustodyArrangement(data: any) {
        return axios.post(ApiURLs.updateCustodyArrangement, data);
    }

    saveEmergencyContacts(childId: string, emergencyContacts: EmergencyContact[]) {
        const emergencyContactsModel = {emergencyContacts};

        return axios.post(ApiURLs.saveEmergencyContacts, emergencyContactsModel, {
            params: { childId }
        } as AxiosRequestConfig)
    }

    updateEmergencyContacts(childId: string, emergencyContacts: EmergencyContact[]) {
        const emergencyContactsModel = { emergencyContacts };

        return axios.post(ApiURLs.updateEmergencyContacts, emergencyContactsModel, {
            params: { childId }
        } as AxiosRequestConfig)
    }

    savePickupPersons(childId: string, pickupPersons: PickupPerson[]) {
        const pickupPersonsModel = { pickupPersons };

        return axios.post(ApiURLs.savePickupPersons, pickupPersonsModel, {
            params: { childId }
        } as AxiosRequestConfig)
    }
    
    updatePickupPersons(childId: string, pickupPersons: PickupPerson[]) {
        const pickupPersonsModel = {pickupPersons};

        return axios.post(ApiURLs.updatePickupPersons,pickupPersonsModel, {
            params:{childId}
        } as AxiosRequestConfig)
    }
    
    saveChosenVaccinationDates(data: FormData) {
        return axios.post(ApiURLs.saveChosenVaccinationDates, data);
    }
    
    updateChosenVaccinationDates(data: FormData) {
        return axios.post(ApiURLs.updateChosenVaccinationDates, data);
    }
 
    saveAllergyInfo(childId: string, data: any) {
        console.log(ApiURLs.saveAllergyInfo);
        
        return axios.post(ApiURLs.saveAllergyInfo, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }
    
    updateAllergyInfo(childId: string, data: any) {
        return axios.post(ApiURLs.updateAllergyInfo, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }

    saveSkinProducts(childId:string, data:any) {
        return axios.post(ApiURLs.saveSkinProducts, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }

    updateSkinProducts(childId: string, data: any) {
        return axios.post(ApiURLs.updateSkinProducts, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }
 
    updateHealthInfo (childId: string, data: any) {
        const d = { ...data };

        return axios.post(ApiURLs.updateHealthInfo, d, {
            params: { childId }
        } as AxiosRequestConfig);
    }

    saveHealthInfo(childId: string, data: any) {
        const d = { ...data };

        return axios.post(ApiURLs.saveHealthInfo, data, {
            params: { childId }
        } as AxiosRequestConfig);
    }

    updateFeedingArrangment(childId: string, data: any) {
        return axios.post(ApiURLs.updateFeedingArrangment, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }
    
    saveFeedingArrangment(childId: string, data: any) {
        return axios.post(ApiURLs.saveFeedingArrangment, data, {
            params: {childId}
        } as AxiosRequestConfig);
    }

    savePhysicalRequirements(data: PhysicalRequirement) {
        return axios.post(ApiURLs.savePhysicalRequirements, data);
    }

    updatePhysicalRequirements(data: PhysicalRequirement) {
        return axios.post(ApiURLs.updatePhysicalRequirements, data);
    }

    saveSleepArrangement(data: SleepArragement) {
        return axios.post(ApiURLs.saveSleepArrangement, data);
    }

    updateSleepArrangement(data: SleepArragement) {
        return axios.post(ApiURLs.updateSleepArrangement, data);
    }
    
    saveAdditionalEmergencyInfo(childId: string, additionalEmergencyInfo: string) {
        return axios.post(ApiURLs.saveAdditionalEmergencyInfo, null, {
            params: { childId, additionalEmergencyInfo }
        } as AxiosRequestConfig);
    }

    updateAdditionalEmergencyInfo(childId: string, additionalEmergencyInfo: string) {
        return axios.post(ApiURLs.updateAdditionalEmergencyInfo, null, {
            params:{childId, additionalEmergencyInfo}
        } as AxiosRequestConfig);
    }

    updateAdditionalInfo(childId: string, additionalInfo: string) {
        return axios.post(ApiURLs.updateAdditionalInfo, null, {
            params: {  childId, additionalInfo }
        } as AxiosRequestConfig);
    }

    saveAdditionalInfo(childId: string, additionalInfo: string) {
        return axios.post(ApiURLs.saveAdditionalInfo, null, {
            params:{childId, additionalInfo}
        } as AxiosRequestConfig);
    }

    skipEnrollmentStep (childId: string, stepCompleted: number) {
        return axios.post(ApiURLs.skipEnrollmentStep, null, {
            params:{childId, stepCompleted}
        } as AxiosRequestConfig)
    }

    updateCurrentViewedStep (childId: string, step: number) {
        return axios.post(ApiURLs.updateCurrentViewedStep, null, {
            params: { childId, step }
        } as AxiosRequestConfig)
    }

    deleteChild(childId: string) {
        return axios.delete(ApiURLs.deleteChild, { params: { childId } });
    }
}

export default new ChildServiceCommands();